<script setup lang="ts">
import { onMounted, watchEffect } from 'vue';
import { useBrandingStore } from '@/stores/branding';
import { useUiStore } from '@/stores/ui';

const ui = useUiStore();
const marca = useBrandingStore();

/**
 * A ABA SEGUE O NOME CONFIGURADO.
 *
 * O `<title>` do `index.html` é escrito uma vez e nunca mais muda. Quem
 * troca o nome do app em Configurações → Aparência via o logo e as telas
 * mudarem, e a aba do navegador continuar com o nome antigo — dois nomes
 * para o mesmo produto, na mesma janela.
 *
 * O `index.html` continua tendo o padrão: é ele que aparece enquanto o
 * JavaScript carrega, e uma aba em branco é pior que um nome provisório.
 * Aqui só corrigimos assim que a marca real chega.
 */
watchEffect(() => {
  document.title = marca.appName;
});

onMounted(() => {
  // Sem sessão também: a tela de entrada e o funil já mostram a marca, e
  // a aba não pode ser o único lugar que fica para trás.
  void marca.initialize();

  ui.applyTheme();

  // Acompanha a troca de tema do sistema operacional enquanto o usuário
  // estiver em "system".
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  media.addEventListener('change', () => {
    if (ui.theme === 'system') ui.applyTheme();
  });
});
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--t-fast);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
